import { apiCartProvider } from "./cart.api";

export const cartService = apiCartProvider;
